import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function PrivateRoute({ children, adminOnly = false }) {
  const {
    currentUser,
    userRole,
    loading
  } = useAuth()

  // React Router konum bilgisini yakalayalım
  const location = useLocation()

  // 1) Eğer hala loading ise, henüz kullanıcı bilgilerini bilmiyoruz demektir
  if (loading) {
    return <div>Veri yükleniyor...</div>
  }

  // 2) Kullanıcı henüz yoksa (yani giriş yapmamışsa) /login'e yönlendir
  if (!currentUser) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname }}
      />
    )
  }

  // 3) adminOnly bir rota ise ve kullanıcı admin değilse /'a yönlendir
  if (adminOnly && userRole !== 'admin') {
    return <Navigate to="/" replace />
  }

  // 4) Kullanıcının nickname'i yoksa, ancak şu an /profile sayfasında değilse, oraya yönlendir
  const hasNickname = currentUser.nickname && currentUser.nickname.trim() !== ''
  if (!hasNickname && location.pathname !== '/profile') {
    return <Navigate to="/profile" replace />
  }

  // 5) Observer rolü sadece raporlar sayfasını (card reporting) görebilir
  if (userRole === 'observer') {
    const allowedObserverPaths = ['/', '/todolist', '/view-answers-card', '/profile', '/workspaces']
    const isWorkspaceDetail = location.pathname.startsWith('/workspace/')
    if (!allowedObserverPaths.includes(location.pathname) && !isWorkspaceDetail) {
      return <Navigate to="/view-answers-card" replace />
    }
  }

  // 6) Tüm şartlar sağlandığında, hedef bileşeni render et
  return children
}
